import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ENGINE_API_SETTINGS } from '@ethic/ng-kit';
import {
  incorrectEmailOrCodeNotification,
  loginErrorNotification,
  logoutSuccessNotification,
} from '../config';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { BrowserSupportComponent } from './browser-support/browser-support.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [LoginFormComponent, ForgotPasswordComponent, BrowserSupportComponent],
  imports: [
    BrowserModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule.forRoot([
      {
        path: 'reset-password.html',
        loadChildren: () => import('./reset/reset.module').then((m) => m.ResetModule),
      },
      {
        path: 'reset-password-request-success.html',
        loadChildren: () => import('./reset/reset.module').then((m) => m.ResetModule),
      },
      {
        path: 'reset-password-request-error.html',
        loadChildren: () => import('./reset/reset.module').then((m) => m.ResetModule),
      },
      {
        path: 'signup',
        loadChildren: () => import('./signup/signup.module').then((m) => m.SignupModule),
      },
      {
        path: 'signup-error',
        loadChildren: () => import('./signup/signup.module').then((m) => m.SignupModule),
      },
      {
        path: 'signup-success',
        loadChildren: () => import('./signup/signup.module').then((m) => m.SignupModule),
      },
      {
        path: 'change-password.html',
        loadChildren: () => import('./change/change.module').then((m) => m.ChangeModule),
      },
      {
        path: 'code.html',
        loadChildren: () => import('./code/code.module').then((m) => m.CodeModule),
      },
      {
        path: 'code-error.html',
        loadChildren: () => import('./code/code.module').then((m) => m.CodeModule),
        data: { notification: incorrectEmailOrCodeNotification },
      },
      {
        path: 'forgot-password.html',
        component: ForgotPasswordComponent,
      },
      {
        path: 'login.html',
        component: LoginFormComponent,
      },
      {
        path: 'activate.html',
        loadChildren: () => import('./activate/activate.module').then((m) => m.ActivateModule),
      },
      {
        path: 'activate-success.html',
        loadChildren: () => import('./activate/activate.module').then((m) => m.ActivateModule),
      },
      {
        path: 'activate-error.html',
        loadChildren: () => import('./activate/activate.module').then((m) => m.ActivateModule),
      },
      {
        path: 'login-logout-success.html',
        component: LoginFormComponent,
        data: { notification: logoutSuccessNotification },
      },
      {
        path: 'login-error.html',
        component: LoginFormComponent,
        data: { notification: loginErrorNotification },
      },
      {
        path: 'browser-support.html',
        component: BrowserSupportComponent,
        data: { notification: loginErrorNotification },
      },
      {
        path: 'delete-success',
        loadChildren: () =>
          import('./delete-success/delete-success.module').then((m) => m.DeleteSuccessModule),
      },
      { path: '**', redirectTo: '/login.html', pathMatch: 'full' },
    ]),
  ],
  bootstrap: [AppComponent],
  providers: [{ provide: ENGINE_API_SETTINGS, useValue: environment.engineApiSettings }],
})
export class LoginAppModule {}
